import React from 'react';
import PropTypes from 'prop-types';

import HomeTabAdd from 'ROOT/src/components/home/HomeTabAdd';
import ErrorBoundary from 'ROOT/src/components/home/ErrorBoundary';
import HomeOrig from 'ROOT/src/components/home/home';
import DashboardWidget from './DashboardWidget';
import Footer from './Footer';

/**
 * CHILDREN
 */
import HomeColumns from 'ROOT/views/portal/components/Home/HomeColumns';

/**
 * @parent  src\components\app.js
 * @props     data={store.appReducer.home}
 *            way="home"
 *
 * zobrazuje zalozky na HP, kde jsou dale boxy na budiky
 */
class Home extends HomeOrig {
    render() {
        const data = this.props.data;

        if (!data) return '';

        let activeId = data.get('activeId');
        const way = this.props.way;
        // const renderDataTabMenu = data.tabs.map((tab) => tab.name);
        const tabSize = data.tabs.size;

        if (!Number.isInteger(activeId) || activeId >= tabSize) {
            activeId = 0;
        }

        return (
            <ErrorBoundary>
                {/* Tab menu */}
                <div id="dashboardPageContainer">
                    <div className="contentContainer">
                        <div className="contentWrapper">
                            <DashboardWidget />
                            <div className="pageContainer HomeViewContainer">
                                {/* Obsah tabu */}

                                <div className="home">
                                    {tabSize > 0 ? (
                                        <HomeColumns data={data.tabs.get(activeId)} way={way+'/tabs/'+activeId+'/cols'} />
                                    ) : (
                                        <HomeTabAdd />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </ErrorBoundary>
        );
    }
}

Home.propTypes = {
    data: PropTypes.oneOfType([PropTypes.object.isRequired, PropTypes.object]),
};

export default Home;
